import PageLayout from './PageLayout';
import SystemLayout from './SystemLayout';

const EXPORT = {
  PageLayout,
  SystemLayout,
};

export default EXPORT;
